import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { Redirect, useParams } from 'react-router';
import { IRouteParams } from '../../pages/container/container';
import { useStore } from '../../store/store-provider';
import { getDefaultRoutePathByPermissions } from '../../utils/helpers/features-routes-helpers';
import { Permissions } from '../../store/permissions-store/permissions-store';

interface IProps {
  shouldRedirect: boolean;
  variant: Permissions.QandA | Permissions.PresenterQuestions;
}

const QandaPermissionHOC: FC<IProps> = observer((props): JSX.Element | null => {
  const { permissionsStore } = useStore();
  const { isPodiumQandaEnabled, isPodiumEnabled, isPodiumPresenterQuestionsEnabled } = permissionsStore;
  const shouldRedirect = (isPodiumQandaEnabled() === false || isPodiumEnabled() === false) && props.shouldRedirect;

  const permissionMap = {
    [Permissions.QandA]: isPodiumQandaEnabled(),
    [Permissions.PresenterQuestions]: isPodiumPresenterQuestionsEnabled()
  };

  if (permissionMap[props.variant] && isPodiumEnabled()) {
    return <>{props.children}</>;
  } else if (shouldRedirect) {
    const { id } = useParams<IRouteParams>();
    const path = getDefaultRoutePathByPermissions(permissionsStore);
    return <Redirect to={`/presentation/${id}${path}`}/>;
  } else {
    return null;
  }
});

export { QandaPermissionHOC };
